<template lang="pug">
div
  router-view(v-if="ready")
  div.tipDialog-cover(v-if="showTip")
    div.tipDialog
      i(@click="showTip = false") 
      p 完善报名信息提示
      span(style="display: block;width: 100%;height: 96px;padding: 0 30px;")
        | {{tip}}
        br
        | 修改入口：CNSET公众号-个人中心
      img(src="https://17ks.chivoxapp.com/cnset/cnset-pubic.jpg")
      span(style="line-height: 16px;color: #333;") CNSET官方公众号
      label(@click="showTip = false") 我已知晓
</template>

<script>
import { getStudentInfo } from '@/api/index'

export default {
  name: 'App',
  data() {
    return {
      ready: false,
      showTip: false,
      tip: ''
    }
  },
  methods: {
    fn(string) {
      const $key = this.$Utf8.parse('zMWFUBwzvUWJVxHWplatform')
      const $iv = this.$Utf8.parse('4563262494851526')
      // 默认cbc Pkcs7
      return this.$AES
        .decrypt(string, $key, {
          iv: $iv
        })
        .toString(this.$Utf8)
    }
  },
  created() {
    document.title = window.ConfigNew.header.title
    // 获取学生信息，存入store中
    getStudentInfo(res => {
      if (res.status === 1) {
        let data = JSON.parse(this.fn(res.data))
        this.$store.commit('student/init', data)
        this.$store.commit('setVipInfo', data.vip)
        localStorage.setItem('defaultGrade', JSON.stringify(res.data.defaultGrade))
        this.ready = true

        // 信息审核结果
        let _ot = localStorage.getItem('checkErr') || ''
        let _now = new Date().toLocaleDateString()
        console.info('------', this.$route)
        if (_ot !== _now) {
          const { certificate, photo } = data.checkInfo
          if (+certificate === 1 || +photo === 1) {
            if (certificate + photo === 2) {
              this.tip =
                '请修改照片为小2寸免冠证件照，并完善证件号（身份证号）、修改证件类型，否则会影响纸质证书的制作和发放。'
            } else if (+certificate === 1) {
              this.tip =
                '请完善证件号（身份证号）、修改证件类型，否则会影响纸质证书的制作和发放。'
            } else {
              this.tip = '请修改照片为小2寸免冠证件照，否则会影响纸质证书的制作和发放。'
            }
            this.showTip = true
            localStorage.setItem('checkErr', new Date().toLocaleDateString())
          }
        }
      } else this.requestFail(res)
    })
  }
}
</script>

<style lang="less">
@import url('./ui/css/ui.css');
#app {
  min-width: 1180px;
  min-height: 100vh;
}
.iconfont {
  font-family: 'iconfont' !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}
@font-face {
  font-family: 'iconfont'; /* project id 986912 */
  src: url('//at.alicdn.com/t/font_986912_8c1wwvxsspd.eot');
  src: url('//at.alicdn.com/t/font_986912_8c1wwvxsspd.eot?#iefix')
      format('embedded-opentype'),
    url('//at.alicdn.com/t/font_986912_8c1wwvxsspd.woff2') format('woff2'),
    url('//at.alicdn.com/t/font_986912_8c1wwvxsspd.woff') format('woff'),
    url('//at.alicdn.com/t/font_986912_8c1wwvxsspd.ttf') format('truetype'),
    url('//at.alicdn.com/t/font_986912_8c1wwvxsspd.svg#iconfont') format('svg');
}

.tipDialog-cover {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99;
  .tipDialog {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -255px 0 0 -217px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 434px;
    height: 510px;
    background: #ffffff;
    border-radius: 10px;

    i {
      position: absolute;
      top: 14px;
      right: 15px;
      display: block;
      width: 21px;
      height: 21px;
      background: url(/static/images/icon-close.png) no-repeat center center;
      cursor: pointer;
    }

    p {
      margin: 34px 0 27px;
      font-size: 24px;
      line-height: 24px;
      font-weight: bold;
      color: #666666;
      text-align: center;
    }

    span {
      font-size: 16px;
      color: #666666;
      line-height: 24px;
    }

    img {
      display: block;
      width: 184px;
      height: 184px;
      margin: 11px 0 10px;
    }

    label {
      display: block;
      width: 170px;
      height: 56px;
      line-height: 54px;
      border: 1px solid #999;
      border-radius: 28px;
      background: #ffffff;
      margin-top: 24px;
      font-size: 20px;
      color: #666666;
      text-align: center;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue